export const SUBMIT_DISCOVER_PAGE_TITLES = 'la/domain/discoverPages/SUBMIT_DISCOVER_PAGE_TITLES';
export const SUBMIT_DISCOVER_PAGE_TITLES_SUCCESS = 'la/domain/discoverPages/SUBMIT_DISCOVER_PAGE_TITLES_SUCCESS';
export const SUBMIT_DISCOVER_PAGE_TITLES_ERROR = 'la/domain/discoverPages/SUBMIT_DISCOVER_PAGE_TITLES_ERROR';
